const riot = require('riot');

riot.tag2('page-admin-distribution-rules', '<div class="s-full f"> <div data-is="module-sidebar"></div> <div class="s-full f fclm p40 bg-gray_light_10 overflow-scroll"> <div class="f fm fbw mb20"> <div class="lh15 fs30 fw3">配布ルール一覧</div> </div> <div class="s-full f fclm p20 bg-white overflow-hidden"> <div class="relative w160 mb20"> <select class="select s-full lh14 cursor-pointer" ref="role" onchange="{onChangeFilter}"> <option each="{role in app.data.constants.distribution_rule_statuses}" riot-value="{role.id}" selected="{role.id===&quot;in_review&quot;}">{role.name}</option> <option value="">全て</option> </select> <div class="absolute r8 t0 b0 f fh pointer-none"><i class="material-icons fs20 text-gray_dark_10">arrow_drop_down</i></div> </div> <div class="f fm border-bottom border-top border-gray_light_10 bg-primary_light_50 py10 px16"> <div class="flex-fixed w142">作成日時</div> <div class="flex-fixed w102 pl16">ステータス</div> <div class="flex-fixed w180 pl16">配布ルール名</div> <div class="w-full pl16">会社名</div> <div class="w-full pl16">プロジェクト名</div> <div class="w-full pl16">キャンペーン名</div> </div> <div class="s-full overflow-scroll mb20"> <div class="f fm fbw px16 py20 border-bottom border-gray_light_10 cursor-pointer {&quot;bg-gray_light_20 text-gray_dark_20&quot; : !!rule.archived_at}" each="{rule in distributionRules}" onclick="{onGoDistibutionRulesSingle}"> <div class="flex-fixed f fm w142"><i class="material-icons fs20 mr4" if="{!!rule.archived_at}">archive</i> <div class="line-clamp-1">{dayjs(rule.created_at).format(\'YYYY-MM-DD HH:mm\')}</div> </div> <div class="flex-fixed f w102 pl16"> <div class="f fm py4 px7 rounded-4 text-white bg-{getStatus(rule).color}"><i class="material-icons fs12 mr4">{getStatus(rule).icon}</i> <div class="fs12">{getStatus(rule).name}</div> </div> </div> <div class="flex-fixed w180 pl16 line-clamp-1 word-break-all">{rule.name}</div> <div class="w-full pl16 line-clamp-1 word-break-all">{rule.company.name}</div> <div class="w-full pl16 line-clamp-1 word-break-all">{rule.project.name}</div> <div class="w-full pl16 line-clamp-1 word-break-all">{rule.campaign.name}</div> </div> </div> <div class="f fr mta mr20"> <div ref="pagination" data-is="atom-pagination" pagination="{pagination}"></div> </div> </div> </div> </div>', 'page-admin-distribution-rules,[data-is="page-admin-distribution-rules"]{display:block}', '', function(opts) {

    this.limit = 10;

    this.preload = async({cached}) => {
      if (spat.isNode) return;
      if (cached) return;
      app.utils.auth.validateOperator();
      this.fetchDistributionRules();
    };

    this.head = () => {
      return {
        title: app.utils.head.title('配布ルール一覧', this),
      };
    };

    this.on('mount', () => {

      this.refs.pagination.on('paginationchange', async (offset_type) => {
        var offset = this.pagination[offset_type];
        var status = this.refs.role.value;
        var query = {
          offset,
          status,
        };
        this.fetchDistributionRules(query);
      });
    });

    this.onChangeFilter = () => {
      var status = this.refs.role.value;
      var query = {
        status,
      };
      this.fetchDistributionRules(query);
    };

    this.fetchDistributionRules = async ({offset=0, status=''}={}) => {
      var indicator = spat.modal.indicator();
      try {
        var { distribution_rules, pagination } = await app.api.child('distribution_rules').get({offset, status, limit: this.limit});
        this.distributionRules = distribution_rules;
        this.pagination = pagination;
        this.update();
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    this.getStatus = (rule) => {
      return app.data.constants.distribution_rule_statuses.find(s => s.id === rule.status);
    };

    this.onGoDistibutionRulesSingle = (e) => {
      var company_id = e.item.rule.company.id;
      var project_id = e.item.rule.project.id;
      var campaign_id = e.item.rule.campaign.id;
      var distribution_rules_id = e.item.rule.id;

      spat.router.push(`/admin/companies/${company_id}/projects/${project_id}/campaigns/${campaign_id}/distribution_rules/${distribution_rules_id}`);
    };
});